var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2520,
    height: 1700,
    viewBox: "0 0 2520 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1126.64 779V855.971V908.792V958.612V992.825V1357.17V1376.98V1395.59L1305.52 1398.59H1333.73H1352.33H1540V1351.77V1342.16V992.825V957.411V779H1198.07H1126.64Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.60144
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M1541.41 778.5V855.971V856.571V907.591V909.392V957.411V958.612V992.825V1355.97V1376.98V1395.59L1705.28 1397.99H1733.49H1752.09H1946V1351.77V1342.16V992.825V957.411V778.5H1597.83H1541.41Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.60144
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M548.012 780H830.725H1056.41H1126V816.955V992.826V1398.59H956.175H933.366H914.158H795.911H785.707H707.075H548.012V780Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.60144
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1181 574V685H957.376H882.947H864.939V778.54H546V974.818V1017.44V1400.5H292V1050.86V1029.85V980.031V938.615V150.5H924.963H1152.5V224H1147.05V574H1181Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.60144
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M2367 151.5H1504.5V244H1511.5V557.651V593.066V602H1692.5V685H1769V777.939H1946.57V1100.27V1398H2367V993.426V957.411V593.066V551.049V499.428V404.59V151.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.60144
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor4);
export default __webpack_public_path__ + "static/media/select-floor-4.0ac09ba3.svg";
export { ForwardRef as ReactComponent };